import './style.scss';

const PriceV2 = ({ error = false, disabled = false, ...rest }) => {
    return (
        <div className={`price${error ? ' has-error' : ''}${disabled ? ' disabled' : ''}`}>
            <div className='price__unit'>
                $
            </div>

            <div className='price__input'>
                <input
                    type="number"
                    {...rest}
                    disabled={disabled}
                    step="0.01"
                />
            </div>
        </div>
    )
}

export default PriceV2;
